var _path, _rect, _rect2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFenceForeground(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 380,
    height: 169,
    viewBox: "0 0 380 169",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M143.627 50V69.7785H91.4663V50H71.8137V69.7785H17.9663V50H0V168.671H17.9663V148.893H71.8137V168.671H91.4663V148.893H143.627V168.671H161.966V148.893H215.441V168.671H234.966V148.893H287.255V168.671H306.466V148.893H359.068V168.671H379.966V50H359.068V69.7785H306.466V50H287.255V69.7785H234.966V50H215.441V69.7785H161.966V50H143.627ZM17.9663 86.502H71.8137V132.171H17.9663V86.502ZM91.4663 86.502H143.627V132.171H91.4663V86.502ZM161.966 86.502H215.441V132.171H161.966V86.502ZM234.966 86.502H287.255V132.171H234.966V86.502ZM306.466 86.502H359.068V132.171H306.466V86.502Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 52,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 359,
    width: 21,
    height: 52,
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFenceForeground);
export default __webpack_public_path__ + "static/media/fence-foreground.9a7f76f3573eab1bc50dafe52ed78736.svg";
export { ForwardRef as ReactComponent };